// import React, { useState, useEffect } from 'react';
// import { getPayments, processPayment, refundPayment, getPaymentById } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// /* ============================================================
//  * MODERN UI PRIMITIVES (mirror PrimaryRouteManage.css)
//  * ============================================================ */
// const ICON_PATHS = {
//     route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
//     check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
//     calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
//     pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
//     clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
//     stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
//     search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
//     eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
//     trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
//     grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
//     list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
//     tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
//     plus: 'M12 5v14 M5 12h14',
//     map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
//     bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
//     edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
//     info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
//     refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
//     x: 'M18 6 6 18 M6 6l12 12'
// };

// const Icon = ({ name, size = 18 }) => (
//     <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
//         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//         <path d={ICON_PATHS[name]} />
//     </svg>
// );

// const BusSvg = ({ size = 34 }) => (
//     <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
//         <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
//         <rect x="2" y="19" width="58" height="4" fill="#d97706" />
//         <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
//         <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
//         <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
//         <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
//     </svg>
// );

// const useCountUp = (target, duration = 900) => {
//     const [value, setValue] = useState(0);
//     useEffect(() => {
//         let raf, start;
//         const step = (t) => {
//             if (!start) start = t;
//             const p = Math.min((t - start) / duration, 1);
//             setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
//             if (p < 1) raf = requestAnimationFrame(step);
//         };
//         raf = requestAnimationFrame(step);
//         return () => cancelAnimationFrame(raf);
//     }, [target, duration]);
//     return value;
// };

// const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
//     const shown = useCountUp(value);
//     return (
//         <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
//             <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
//             <div className="prm-stat-body">
//                 <div className="prm-stat-label">{label}</div>
//                 <div className="prm-stat-value">{shown}</div>
//                 <div className="prm-stat-hint">{hint}</div>
//             </div>
//         </div>
//     );
// };

// const Switch = ({ checked, onChange, title }) => (
//     <label className="prm-switch" title={title}>
//         <input type="checkbox" checked={checked} onChange={onChange} />
//         <span />
//     </label>
// );

// const FormSection = ({ n, title, hint, children, delay = 0 }) => (
//     <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
//         <header className="prm-fsec-head">
//             <span className="prm-fsec-num">{n}</span>
//             <div>
//                 <h4>{title}</h4>
//                 {hint && <p>{hint}</p>}
//             </div>
//         </header>
//         <div className="prm-fsec-body">{children}</div>
//     </section>
// );

// const Field = ({ label, required, children, full, note }) => (
//     <div className={`prm-field ${full ? 'full' : ''}`}>
//         {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
//         {children}
//         {note && <small className="prm-note">{note}</small>}
//     </div>
// );

// const PrmCheckbox = ({ label, checked, onChange }) => (
//     <label className={`prm-check ${checked ? 'on' : ''}`}>
//         <input type="checkbox" checked={checked} onChange={onChange} />
//         <span className="box"><Icon name="check" size={12} /></span>
//         <span className="txt">{label}</span>
//     </label>
// );

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>PNR No</th>
//           <th>Date & Time</th>
//           <th>User</th>
//           <th>Base Fare</th>
//           <th>Platform Fees</th>
//           <th>CGST</th>
//           <th>SGST</th>
//           <th>IGST</th>
//           <th>Total</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonFilterPanel = () => (
//   <div className="filter-panel skeleton">
//     <div className="filter-header">
//       <div className="skeleton-title"></div>
//       <div className="skeleton-close"></div>
//     </div>
//     <div className="filter-grid">
//       {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
//         <div key={i} className="filter-group">
//           <div className="skeleton-label"></div>
//           <div className="skeleton-input"></div>
//         </div>
//       ))}
//     </div>
//     <div className="filter-actions">
//       <div className="skeleton-button"></div>
//       <div className="skeleton-button"></div>
//     </div>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => (
//           <div key={i} className="skeleton-detail-row">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-value"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const PaymentReport = () => {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingPayment, setViewingPayment] = useState(null);
//   const [processingPayment, setProcessingPayment] = useState(null);
//   const [refundingPayment, setRefundingPayment] = useState(null);
//   const [refundAmount, setRefundAmount] = useState('');
//   const [refundReason, setRefundReason] = useState('');
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);
//   const { token } = useSelector(state => state.user);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalPayments, setTotalPayments] = useState(0);
//   const [pageSize] = useState(10);

//   const [filters, setFilters] = useState({
//     status: 'All Status',
//     method: 'All Methods',
//     startDate: '',
//     endDate: '',
//     pnr: '',
//     userName: '',
//     userEmail: '',
//     userPhone: '',
//     bookingId: '',
//     minAmount: '',
//     maxAmount: ''
//   });
//   const [showFilters, setShowFilters] = useState(false);
//   const [isFiltered, setIsFiltered] = useState(false);

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchPayments();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters]);

//   const fetchPayments = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);
      
//       const filterParams = {};
      
//       if (searchTerm) {
//         filterParams.search = searchTerm;
//       }
      
//       Object.keys(filters).forEach(key => {
//         if (filters[key] && filters[key] !== 'All Status' && filters[key] !== 'All Methods') {
//           filterParams[key] = filters[key];
//         }
//       });

//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         ...filterParams
//       };

//       console.log('Fetching payments with params:', params);

//       const response = await getPayments(params, token);
      
//       if (response && response.success) {
//         console.log('Payments response:', response);
        
//         const formattedPayments = response.payments.map(payment => {
//           const rawData = payment.rawData || payment;
          
//           const pnr = rawData.pnr || payment.pnr || payment.transaction || `TXN${payment.id?.slice(-8) || 'N/A'}`;
          
//           const pricing = rawData.pricing || {};
//           const baseFare = pricing.totalAmount || pricing.baseAmount || payment.amount || 0;
//           const platformFee = pricing.platformFee || 0;
//           const cgst = pricing.cgst || 0;
//           const sgst = pricing.sgst || 0;
//           const igst = pricing.igst || 0;
//           const total = pricing.payableAmount || (baseFare + platformFee + cgst + sgst + igst) || payment.amount || 0;
          
//           const user = rawData.user || {};
//           const userName = user.name || payment.user || 'N/A';
//           const userEmail = user.email || payment.userEmail || 'N/A';
//           const userPhone = user.phone || payment.userPhone || 'N/A';
          
//           const createdAt = rawData.createdAt || payment.date;
//           let date = payment.date || 'N/A';
//           let time = payment.time || 'N/A';
          
//           if (createdAt && !payment.date) {
//             const d = new Date(createdAt);
//             date = d.toLocaleDateString('en-IN');
//             time = d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
//           }
          
//           return {
//             id: payment.id,
//             pnr: pnr,
//             date: date,
//             time: time,
//             user: userName,
//             userEmail: userEmail,
//             userPhone: userPhone,
//             baseFare: baseFare,
//             platformFee: platformFee,
//             cgst: cgst,
//             sgst: sgst,
//             igst: igst,
//             total: total,
//             method: payment.method || 'Online',
//             booking: payment.booking || 'N/A',
//             status: payment.status || 'pending',
//             paymentStatus: payment.paymentStatus || payment.status || 'pending',
//             rawData: payment
//           };
//         });

//         setPayments(formattedPayments);
//         setTotalPages(response.totalPages || 1);
//         setTotalPayments(response.total || 0);
        
//         const hasActiveFilters = 
//           filters.status !== 'All Status' || 
//           filters.method !== 'All Methods' || 
//           searchTerm !== '' || 
//           Object.values(filters).some(value => 
//             value && value !== '' && value !== 'All Status' && value !== 'All Methods'
//           );
//         setIsFiltered(hasActiveFilters);
//       } else {
//         setError('Failed to fetch payments.');
//         setPayments([]);
//       }
//     } catch (err) {
//       console.error('Error fetching payments:', err);
//       setError('Failed to fetch payments. Please try again.');
//       setPayments([]);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const getSafeString = (value) => {
//     if (value === null || value === undefined) return '';
//     return String(value);
//   };

//   const getSafeLowerCase = (value) => {
//     if (value === null || value === undefined) return '';
//     return String(value).toLowerCase();
//   };

//   const getSafeNumber = (value) => {
//     if (value === null || value === undefined) return 0;
//     return Number(value);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setCurrentPage(1);
//     fetchPayments();
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     fetchPayments();
//     setShowFilters(false);
//   };

//   const clearFilters = () => {
//     setFilters({
//       status: 'All Status',
//       method: 'All Methods',
//       startDate: '',
//       endDate: '',
//       pnr: '',
//       userName: '',
//       userEmail: '',
//       userPhone: '',
//       bookingId: '',
//       minAmount: '',
//       maxAmount: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//     setIsFiltered(false);
//   };

//   const toggleFilters = () => {
//     setShowFilters(!showFilters);
//   };

//   const handleExportReport = () => {
//     if (payments.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['PNR No', 'Date', 'Time', 'User', 'User Email', 'User Phone', 'Base Fare', 'Platform Fees', 'CGST', 'SGST', 'IGST', 'Total', 'Status'];
//     const csvData = payments.map(payment => [
//       payment.pnr || '',
//       payment.date || '',
//       payment.time || '',
//       payment.user || '',
//       payment.userEmail || '',
//       payment.userPhone || '',
//       `₹${getSafeNumber(payment.baseFare)}`,
//       `₹${getSafeNumber(payment.platformFee)}`,
//       `₹${getSafeNumber(payment.cgst)}`,
//       `₹${getSafeNumber(payment.sgst)}`,
//       `₹${getSafeNumber(payment.igst)}`,
//       `₹${getSafeNumber(payment.total)}`,
//       payment.status || ''
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `payments-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('Payment report exported successfully!');
//   };

//   const handleViewPayment = async (payment) => {
//     try {
//       setIsFetchingDetails(true);
//       const response = await getPaymentById(payment.id, token);
      
//       if (response.success) {
//         const paymentData = response.data || response.payment;
//         setViewingPayment({
//           ...payment,
//           ...paymentData
//         });
//       }
//     } catch (error) {
//       console.error('Error fetching payment details:', error);
//       setViewingPayment(payment);
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleProcessPayment = (payment) => {
//     setProcessingPayment(payment);
//   };

//   const handleConfirmProcess = async () => {
//     try {
//       const response = await processPayment(processingPayment.id, token);
      
//       if (response.success) {
//         alert('Payment processed successfully!');
//         setProcessingPayment(null);
//         fetchPayments();
//       }
//     } catch (error) {
//       console.error('Error processing payment:', error);
//       alert('Error processing payment: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleRefundPayment = (payment) => {
//     setRefundingPayment(payment);
//     setRefundAmount(payment.total);
//     setRefundReason('');
//   };

//   const handleConfirmRefund = async () => {
//     try {
//       const refundData = {
//         refundAmount: parseFloat(refundAmount),
//         reason: refundReason
//       };

//       const response = await refundPayment(refundingPayment.id, refundData, token);
      
//       if (response.success) {
//         alert('Payment refunded successfully!');
//         setRefundingPayment(null);
//         setRefundAmount('');
//         setRefundReason('');
//         fetchPayments();
//       }
//     } catch (error) {
//       console.error('Error refunding payment:', error);
//       alert('Error refunding payment: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const closeViewModal = () => {
//     setViewingPayment(null);
//   };

//   const closeProcessModal = () => {
//     setProcessingPayment(null);
//   };

//   const closeRefundModal = () => {
//     setRefundingPayment(null);
//     setRefundAmount('');
//     setRefundReason('');
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     clearFilters();
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const totalRevenue = payments
//     .filter(p => getSafeLowerCase(p.status) === 'confirmed' || getSafeLowerCase(p.paymentStatus) === 'success')
//     .reduce((sum, payment) => sum + getSafeNumber(payment.total), 0);

//   const successfulPayments = payments.filter(p => 
//     getSafeLowerCase(p.status) === 'confirmed' || getSafeLowerCase(p.paymentStatus) === 'success'
//   ).length;

//   const successRate = totalPayments > 0 ? Math.round((successfulPayments / totalPayments) * 100) : 0;

//   const formatCurrency = (amount) => {
//     return `₹${getSafeNumber(amount).toLocaleString()}`;
//   };

//   const getStatusBadgeClass = (status, paymentStatus) => {
//     const lowerStatus = getSafeLowerCase(status);
//     const lowerPaymentStatus = getSafeLowerCase(paymentStatus);
    
//     if (lowerStatus === 'refunded' || lowerStatus === 'cancelled') return 'refunded';
//     if (lowerPaymentStatus === 'success' || lowerStatus === 'confirmed') return 'completed';
//     if (lowerPaymentStatus === 'pending' || lowerStatus === 'pending') return 'pending';
//     if (lowerPaymentStatus === 'failed' || lowerStatus === 'expired') return 'failed';
//     return 'pending';
//   };

//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;
    
//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
//       if (end - start + 1 < maxVisiblePages) {
//         start = Math.max(1, end - maxVisiblePages + 1);
//       }
      
//       for (let i = start; i <= end; i++) {
//         pages.push(i);
//       }
//     }
    
//     return pages;
//   };

//   if (loading && payments.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Payment Report</h1>
//         <div className="header-actions">
//           <form onSubmit={handleSearchSubmit} className="search-form">
//             <div style={{ position: 'relative' }}>
//               <input 
//                 type="text" 
//                 placeholder="Search by PNR, user or booking..." 
//                 className="search-input" 
//                 value={searchTerm}
//                 onChange={handleSearchChange}
//                 style={{ width: "300px" }}
//               />
//               {searching && (
//                 <span style={{
//                   position: 'absolute', right: '10px', top: '50%',
//                   transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//                 }}>
//                   searching...
//                 </span>
//               )}
//             </div>
//           </form>
//           <button className="filter-btn" onClick={toggleFilters}>
//             🔍 Filters
//           </button>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportReport}>
//             Export Report
//           </button>
//         </div>
//       </div>


//       {showFilters && !loading && (
//         <div className="filter-panel">
//           <div className="filter-header">
//             <h3>Filter Payments</h3>
//             <button className="close-filters" onClick={() => setShowFilters(false)}>
//               ×
//             </button>
//           </div>
//           <div className="filter-grid">
//             <div className="filter-group">
//               <label>PNR No</label>
//               <input
//                 type="text"
//                 name="pnr"
//                 value={filters.pnr}
//                 onChange={handleFilterChange}
//                 placeholder="Enter PNR number"
//               />
//             </div>
//             <div className="filter-group">
//               <label>User Name</label>
//               <input
//                 type="text"
//                 name="userName"
//                 value={filters.userName}
//                 onChange={handleFilterChange}
//                 placeholder="Enter user name"
//               />
//             </div>
//             <div className="filter-group">
//               <label>User Email</label>
//               <input
//                 type="email"
//                 name="userEmail"
//                 value={filters.userEmail}
//                 onChange={handleFilterChange}
//                 placeholder="Enter user email"
//               />
//             </div>
//             <div className="filter-group">
//               <label>User Phone</label>
//               <input
//                 type="text"
//                 name="userPhone"
//                 value={filters.userPhone}
//                 onChange={handleFilterChange}
//                 placeholder="Enter user phone"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Booking ID</label>
//               <input
//                 type="text"
//                 name="bookingId"
//                 value={filters.bookingId}
//                 onChange={handleFilterChange}
//                 placeholder="Enter booking ID"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Payment Status</label>
//               <select
//                 name="status"
//                 value={filters.status}
//                 onChange={handleFilterChange}
//               >
//                 <option value="All Status">All Status</option>
//                 <option value="Confirmed">Completed</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Failed">Failed</option>
//                 <option value="Expired">Expired</option>
//                 <option value="Refunded">Refunded</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Payment Method</label>
//               <select
//                 name="method"
//                 value={filters.method}
//                 onChange={handleFilterChange}
//               >
//                 <option value="All Methods">All Methods</option>
//                 <option value="Online">Online</option>
//                 <option value="Cash">Cash</option>
//                 <option value="Card">Card</option>
//                 <option value="UPI">UPI</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Payment From</label>
//               <input
//                 type="date"
//                 name="startDate"
//                 value={filters.startDate}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label>Payment To</label>
//               <input
//                 type="date"
//                 name="endDate"
//                 value={filters.endDate}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label>Min Amount</label>
//               <input
//                 type="number"
//                 name="minAmount"
//                 value={filters.minAmount}
//                 onChange={handleFilterChange}
//                 placeholder="Minimum amount"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Max Amount</label>
//               <input
//                 type="number"
//                 name="maxAmount"
//                 value={filters.maxAmount}
//                 onChange={handleFilterChange}
//                 placeholder="Maximum amount"
//                 min="0"
//               />
//             </div>
//           </div>
//           <div className="filter-actions">
//             <button className="apply-filters-btn" onClick={applyFilters}>
//               Apply Filters
//             </button>
//             <button className="clear-filters-btn" onClick={clearFilters}>
//               Clear All
//             </button>
//           </div>
//           {isFiltered && (
//             <div className="active-filters">
//               <span>Active Filters:</span>
//               {searchTerm && (
//                 <span className="filter-tag">Search: {searchTerm}</span>
//               )}
//               {filters.status !== 'All Status' && (
//                 <span className="filter-tag">Status: {filters.status}</span>
//               )}
//               {filters.method !== 'All Methods' && (
//                 <span className="filter-tag">Method: {filters.method}</span>
//               )}
//               {Object.entries(filters).map(([key, value]) => 
//                 value && 
//                 key !== 'status' && 
//                 key !== 'method' && 
//                 key !== 'startDate' && 
//                 key !== 'endDate' && (
//                   <span key={key} className="filter-tag">
//                     {key}: {value}
//                   </span>
//                 )
//               )}
//               {filters.startDate && (
//                 <span className="filter-tag">From: {filters.startDate}</span>
//               )}
//               {filters.endDate && (
//                 <span className="filter-tag">To: {filters.endDate}</span>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Payments</h3>
//           <p>{totalPayments}</p>
//           <span>All transactions</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Revenue</h3>
//           <p>{formatCurrency(totalRevenue)}</p>
//           <span>successful payments</span>
//         </div>
//         <div className="stat-card">
//           <h3>Success Rate</h3>
//           <p>{successRate}%</p>
//           <span>{successfulPayments}/{totalPayments} payments</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{payments.length}</p>
//           <span>payments found</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>PNR No</th>
//               <th>Date & Time</th>
//               <th>User</th>
//               <th>Base Fare</th>
//               <th>Platform Fees</th>
//               <th>CGST</th>
//               <th>SGST</th>
//               <th>IGST</th>
//               <th>Total</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {payments.length > 0 ? (
//               payments.map(payment => (
//                 <tr key={payment.id}>
//                   <td className="transaction">
//                     <strong>{getSafeString(payment.pnr)}</strong>
//                   </td>
//                   <td>
//                     <div>
//                       <div>{getSafeString(payment.date)}</div>
//                       <div className="phone">{getSafeString(payment.time)}</div>
//                     </div>
//                   </td>
//                   <td>
//                     <div>
//                       <div>{getSafeString(payment.user)}</div>
//                       <div className="phone">{getSafeString(payment.userPhone)}</div>
//                     </div>
//                   </td>
//                   <td>{formatCurrency(payment.baseFare)}</td>
//                   <td>{formatCurrency(payment.platformFee)}</td>
//                   <td>{formatCurrency(payment.cgst)}</td>
//                   <td>{formatCurrency(payment.sgst)}</td>
//                   <td>{formatCurrency(payment.igst)}</td>
//                   <td><strong>{formatCurrency(payment.total)}</strong></td>
//                   <td>
//                     <span className={`status-badge ${getStatusBadgeClass(payment.status, payment.paymentStatus)}`}>
//                       {getSafeString(payment.status === 'Confirmed' ? 'Completed' : payment.status)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button 
//                         className="action-btn view" 
//                         onClick={() => handleViewPayment(payment)}
//                       >
//                         Details
//                       </button>
//                       {(getSafeLowerCase(payment.status) === 'pending' || getSafeLowerCase(payment.paymentStatus) === 'pending') && (
//                         <button 
//                           className="action-btn process" 
//                           onClick={() => handleProcessPayment(payment)}
//                         >
//                           Process
//                         </button>
//                       )}
//                       {(getSafeLowerCase(payment.status) === 'confirmed' || getSafeLowerCase(payment.paymentStatus) === 'success') && (
//                         <button 
//                           className="action-btn delete" 
//                           onClick={() => handleRefundPayment(payment)}
//                         >
//                           Refund
//                         </button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="no-data">
//                   <p>No payments found {isFiltered ? 'matching your filters' : ''}.</p>
//                   {isFiltered && (
//                     <button className="clear-filters-link" onClick={clearFilters}>
//                       Clear filters to see all payments
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>


//       {totalPages > 1 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {payments.length} of {totalPayments} payments
//             (Page {currentPage} of {totalPages})
//             {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//             {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
//           </div>
//           <div className="pagination-controls">
//             <button 
//               className="pagination-btn" 
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
            
//             <div className="page-numbers">
//               {generatePageNumbers().map(pageNumber => (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               ))}
              
//               {totalPages > 5 && currentPage < totalPages - 2 && (
//                 <>
//                   <span className="page-dots">...</span>
//                   <button
//                     className="page-number"
//                     onClick={() => handlePageClick(totalPages)}
//                   >
//                     {totalPages}
//                   </button>
//                 </>
//               )}
//             </div>
            
//             <button 
//               className="pagination-btn" 
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}


//       {viewingPayment && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Payment Details - {getSafeString(viewingPayment.pnr)}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>PNR No:</label>
//                   <span className="transaction"><strong>{getSafeString(viewingPayment.pnr)}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Date:</label>
//                   <span>{getSafeString(viewingPayment.date)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Time:</label>
//                   <span>{getSafeString(viewingPayment.time)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{getSafeString(viewingPayment.user)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{getSafeString(viewingPayment.userEmail)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{getSafeString(viewingPayment.userPhone)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Base Fare:</label>
//                   <span>{formatCurrency(viewingPayment.baseFare)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Platform Fees:</label>
//                   <span>{formatCurrency(viewingPayment.platformFee)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>CGST:</label>
//                   <span>{formatCurrency(viewingPayment.cgst)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>SGST:</label>
//                   <span>{formatCurrency(viewingPayment.sgst)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>IGST:</label>
//                   <span>{formatCurrency(viewingPayment.igst)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Total Amount:</label>
//                   <span className="transaction"><strong>{formatCurrency(viewingPayment.total)}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Payment Method:</label>
//                   <span className={`payment-method ${getSafeLowerCase(viewingPayment.method).replace(' ', '-')}`}>
//                     {getSafeString(viewingPayment.method)}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking Reference:</label>
//                   <span>{getSafeString(viewingPayment.booking)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${getStatusBadgeClass(viewingPayment.status, viewingPayment.paymentStatus)}`}>
//                     {getSafeString(viewingPayment.status === 'Confirmed' ? 'Completed' : viewingPayment.status)}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingPayment && isFetchingDetails && <SkeletonModal />}


//       {processingPayment && (
//         <div className="modal-overlay" onClick={closeProcessModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Process Payment</h3>
//               <button className="modal-close-btn" onClick={closeProcessModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>PNR:</label>
//                   <span className="transaction"><strong>{getSafeString(processingPayment.pnr)}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{getSafeString(processingPayment.user)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Total Amount:</label>
//                   <span><strong>{formatCurrency(processingPayment.total)}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking:</label>
//                   <span>{getSafeString(processingPayment.booking)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Current Status:</label>
//                   <span className="status-badge pending">Pending</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Action:</label>
//                   <span>Mark as Completed</span>
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#f0f9ff', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#0369a1', fontSize: '14px'}}>
//                   <strong>Note:</strong> This will mark the payment as completed and confirm the associated booking.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeProcessModal}>
//                 Cancel
//               </button>
//               <button className="action-btn process" onClick={handleConfirmProcess}>
//                 Confirm Process
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {refundingPayment && (
//         <div className="modal-overlay" onClick={closeRefundModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Refund Payment</h3>
//               <button className="modal-close-btn" onClick={closeRefundModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>PNR:</label>
//                   <span className="transaction"><strong>{getSafeString(refundingPayment.pnr)}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{getSafeString(refundingPayment.user)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Total Amount:</label>
//                   <span><strong>{formatCurrency(refundingPayment.total)}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking:</label>
//                   <span>{getSafeString(refundingPayment.booking)}</span>
//                 </div>
                
//                 <div className="detail-row">
//                   <label>Refund Amount:</label>
//                   <input
//                     type="number"
//                     value={refundAmount}
//                     onChange={(e) => setRefundAmount(e.target.value)}
//                     placeholder="Enter refund amount"
//                     style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px'}}
//                   />
//                 </div>
                
//                 <div className="detail-row">
//                   <label>Refund Reason:</label>
//                   <textarea
//                     value={refundReason}
//                     onChange={(e) => setRefundReason(e.target.value)}
//                     placeholder="Enter reason for refund"
//                     style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px', minHeight: '60px'}}
//                   />
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#856404', fontSize: '14px'}}>
//                   <strong>Warning:</strong> This action will cancel the booking and process a refund. This cannot be undone.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeRefundModal}>
//                 Cancel
//               </button>
//               <button className="action-btn delete" onClick={handleConfirmRefund}>
//                 Confirm Refund
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PaymentReport;

import React, { useState, useEffect } from 'react';
import { getPayments, processPayment, refundPayment, getPaymentById } from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import { useSelector } from 'react-redux';

/* ============================================================
 * MODERN UI PRIMITIVES (mirror PrimaryRouteManage.css)
 * ============================================================ */
const ICON_PATHS = {
    route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
    check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
    calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
    pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
    stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
    search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
    eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
    grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
    list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
    tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
    plus: 'M12 5v14 M5 12h14',
    map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
    bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
    edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
    info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
    refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
    x: 'M18 6 6 18 M6 6l12 12'
};

const Icon = ({ name, size = 18 }) => (
    <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={ICON_PATHS[name]} />
    </svg>
);

const BusSvg = ({ size = 34 }) => (
    <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
        <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
        <rect x="2" y="19" width="58" height="4" fill="#d97706" />
        <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
        <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
        <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
        <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
    </svg>
);

const useCountUp = (target, duration = 900) => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        let raf, start;
        const step = (t) => {
            if (!start) start = t;
            const p = Math.min((t - start) / duration, 1);
            setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
            if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, [target, duration]);
    return value;
};

const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
    const shown = useCountUp(value);
    return (
        <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
            <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
            <div className="prm-stat-body">
                <div className="prm-stat-label">{label}</div>
                <div className="prm-stat-value">{shown}</div>
                <div className="prm-stat-hint">{hint}</div>
            </div>
        </div>
    );
};

const Switch = ({ checked, onChange, title }) => (
    <label className="prm-switch" title={title}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span />
    </label>
);

const FormSection = ({ n, title, hint, children, delay = 0 }) => (
    <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
        <header className="prm-fsec-head">
            <span className="prm-fsec-num">{n}</span>
            <div>
                <h4>{title}</h4>
                {hint && <p>{hint}</p>}
            </div>
        </header>
        <div className="prm-fsec-body">{children}</div>
    </section>
);

const Field = ({ label, required, children, full, note }) => (
    <div className={`prm-field ${full ? 'full' : ''}`}>
        {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
        {children}
        {note && <small className="prm-note">{note}</small>}
    </div>
);

const PrmCheckbox = ({ label, checked, onChange }) => (
    <label className={`prm-check ${checked ? 'on' : ''}`}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="box"><Icon name="check" size={12} /></span>
        <span className="txt">{label}</span>
    </label>
);

const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>PNR No</th>
          <th>Date & Time</th>
          <th>User</th>
          <th>Base Fare</th>
          <th>Platform Fees</th>
          <th>CGST</th>
          <th>SGST</th>
          <th>IGST</th>
          <th>Total</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonFilterPanel = () => (
  <div className="filter-panel skeleton">
    <div className="filter-header">
      <div className="skeleton-title"></div>
      <div className="skeleton-close"></div>
    </div>
    <div className="filter-grid">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
        <div key={i} className="filter-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>
      ))}
    </div>
    <div className="filter-actions">
      <div className="skeleton-button"></div>
      <div className="skeleton-button"></div>
    </div>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => (
          <div key={i} className="skeleton-detail-row">
            <div className="skeleton-label"></div>
            <div className="skeleton-value"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const PaymentReport = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewingPayment, setViewingPayment] = useState(null);
  const [processingPayment, setProcessingPayment] = useState(null);
  const [refundingPayment, setRefundingPayment] = useState(null);
  const [refundAmount, setRefundAmount] = useState('');
  const [refundReason, setRefundReason] = useState('');
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const { token } = useSelector(state => state.user);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPayments, setTotalPayments] = useState(0);
  const [pageSize] = useState(10);

  const [filters, setFilters] = useState({
    status: 'All Status',
    method: 'All Methods',
    startDate: '',
    endDate: '',
    pnr: '',
    userName: '',
    userEmail: '',
    userPhone: '',
    bookingId: '',
    minAmount: '',
    maxAmount: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchPayments();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm, filters]);

  const fetchPayments = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);
      
      const filterParams = {};
      
      if (searchTerm) {
        filterParams.search = searchTerm;
      }
      
      Object.keys(filters).forEach(key => {
        if (filters[key] && filters[key] !== 'All Status' && filters[key] !== 'All Methods') {
          filterParams[key] = filters[key];
        }
      });

      const params = {
        page: currentPage,
        limit: pageSize,
        ...filterParams
      };

      console.log('Fetching payments with params:', params);

      const response = await getPayments(params, token);
      
      if (response && response.success) {
        console.log('Payments response:', response);
        
        const formattedPayments = response.payments.map(payment => {
          const rawData = payment.rawData || payment;
          
          const pnr = rawData.pnr || payment.pnr || payment.transaction || `TXN${payment.id?.slice(-8) || 'N/A'}`;
          
          const pricing = rawData.pricing || {};
          const baseFare = pricing.totalAmount || pricing.baseAmount || payment.amount || 0;
          const platformFee = pricing.platformFee || 0;
          const cgst = pricing.cgst || 0;
          const sgst = pricing.sgst || 0;
          const igst = pricing.igst || 0;
          const total = pricing.payableAmount || (baseFare + platformFee + cgst + sgst + igst) || payment.amount || 0;
          
          const user = rawData.user || {};
          const userName = user.name || payment.user || 'N/A';
          const userEmail = user.email || payment.userEmail || 'N/A';
          const userPhone = user.phone || payment.userPhone || 'N/A';
          
          const createdAt = rawData.createdAt || payment.date;
          let date = payment.date || 'N/A';
          let time = payment.time || 'N/A';
          
          if (createdAt && !payment.date) {
            const d = new Date(createdAt);
            date = d.toLocaleDateString('en-IN');
            time = d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
          }
          
          return {
            id: payment.id,
            pnr: pnr,
            date: date,
            time: time,
            user: userName,
            userEmail: userEmail,
            userPhone: userPhone,
            baseFare: baseFare,
            platformFee: platformFee,
            cgst: cgst,
            sgst: sgst,
            igst: igst,
            total: total,
            method: payment.method || 'Online',
            booking: payment.booking || 'N/A',
            status: payment.status || 'pending',
            paymentStatus: payment.paymentStatus || payment.status || 'pending',
            rawData: payment
          };
        });

        setPayments(formattedPayments);
        setTotalPages(response.totalPages || 1);
        setTotalPayments(response.total || 0);
        
        const hasActiveFilters = 
          filters.status !== 'All Status' || 
          filters.method !== 'All Methods' || 
          searchTerm !== '' || 
          Object.values(filters).some(value => 
            value && value !== '' && value !== 'All Status' && value !== 'All Methods'
          );
        setIsFiltered(hasActiveFilters);
      } else {
        setError('Failed to fetch payments.');
        setPayments([]);
      }
    } catch (err) {
      console.error('Error fetching payments:', err);
      setError('Failed to fetch payments. Please try again.');
      setPayments([]);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const getSafeString = (value) => {
    if (value === null || value === undefined) return '';
    return String(value);
  };

  const getSafeLowerCase = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).toLowerCase();
  };

  const getSafeNumber = (value) => {
    if (value === null || value === undefined) return 0;
    return Number(value);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchPayments();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    setCurrentPage(1);
    fetchPayments();
    setShowFilters(false);
  };

  const clearFilters = () => {
    setFilters({
      status: 'All Status',
      method: 'All Methods',
      startDate: '',
      endDate: '',
      pnr: '',
      userName: '',
      userEmail: '',
      userPhone: '',
      bookingId: '',
      minAmount: '',
      maxAmount: ''
    });
    setSearchTerm('');
    setCurrentPage(1);
    setIsFiltered(false);
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleExportReport = () => {
    if (payments.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = ['PNR No', 'Date', 'Time', 'User', 'User Email', 'User Phone', 'Base Fare', 'Platform Fees', 'CGST', 'SGST', 'IGST', 'Total', 'Status'];
    const csvData = payments.map(payment => [
      payment.pnr || '',
      payment.date || '',
      payment.time || '',
      payment.user || '',
      payment.userEmail || '',
      payment.userPhone || '',
      `₹${getSafeNumber(payment.baseFare)}`,
      `₹${getSafeNumber(payment.platformFee)}`,
      `₹${getSafeNumber(payment.cgst)}`,
      `₹${getSafeNumber(payment.sgst)}`,
      `₹${getSafeNumber(payment.igst)}`,
      `₹${getSafeNumber(payment.total)}`,
      payment.status || ''
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `payments-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    alert('Payment report exported successfully!');
  };

  const handleViewPayment = async (payment) => {
    try {
      setIsFetchingDetails(true);
      const response = await getPaymentById(payment.id, token);
      
      if (response.success) {
        const paymentData = response.data || response.payment;
        setViewingPayment({
          ...payment,
          ...paymentData
        });
      }
    } catch (error) {
      console.error('Error fetching payment details:', error);
      setViewingPayment(payment);
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleProcessPayment = (payment) => {
    setProcessingPayment(payment);
  };

  const handleConfirmProcess = async () => {
    try {
      const response = await processPayment(processingPayment.id, token);
      
      if (response.success) {
        alert('Payment processed successfully!');
        setProcessingPayment(null);
        fetchPayments();
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      alert('Error processing payment: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleRefundPayment = (payment) => {
    setRefundingPayment(payment);
    setRefundAmount(payment.total);
    setRefundReason('');
  };

  const handleConfirmRefund = async () => {
    try {
      const refundData = {
        refundAmount: parseFloat(refundAmount),
        reason: refundReason
      };

      const response = await refundPayment(refundingPayment.id, refundData, token);
      
      if (response.success) {
        alert('Payment refunded successfully!');
        setRefundingPayment(null);
        setRefundAmount('');
        setRefundReason('');
        fetchPayments();
      }
    } catch (error) {
      console.error('Error refunding payment:', error);
      alert('Error refunding payment: ' + (error.response?.data?.message || error.message));
    }
  };

  const closeViewModal = () => {
    setViewingPayment(null);
  };

  const closeProcessModal = () => {
    setProcessingPayment(null);
  };

  const closeRefundModal = () => {
    setRefundingPayment(null);
    setRefundAmount('');
    setRefundReason('');
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    clearFilters();
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalRevenue = payments
    .filter(p => getSafeLowerCase(p.status) === 'confirmed' || getSafeLowerCase(p.paymentStatus) === 'success')
    .reduce((sum, payment) => sum + getSafeNumber(payment.total), 0);

  const successfulPayments = payments.filter(p => 
    getSafeLowerCase(p.status) === 'confirmed' || getSafeLowerCase(p.paymentStatus) === 'success'
  ).length;

  const successRate = totalPayments > 0 ? Math.round((successfulPayments / totalPayments) * 100) : 0;

  const formatCurrency = (amount) => {
    return `₹${getSafeNumber(amount).toLocaleString()}`;
  };

  const getStatusBadgeClass = (status, paymentStatus) => {
    const lowerStatus = getSafeLowerCase(status);
    const lowerPaymentStatus = getSafeLowerCase(paymentStatus);
    
    if (lowerStatus === 'refunded' || lowerStatus === 'cancelled') return 'refunded';
    if (lowerPaymentStatus === 'success' || lowerStatus === 'confirmed') return 'completed';
    if (lowerPaymentStatus === 'pending' || lowerStatus === 'pending') return 'pending';
    if (lowerPaymentStatus === 'failed' || lowerStatus === 'expired') return 'failed';
    return 'pending';
  };

  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
      if (end - start + 1 < maxVisiblePages) {
        start = Math.max(1, end - maxVisiblePages + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  };

  if (loading && payments.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  if (loading && payments.length === 0) {
    return (
      <div className="prm-page">
        <div className="prm-hero">
          <div className="prm-hero-text">
            <span className="prm-eyebrow"><Icon name="wallet" size={13} /> Payments</span>
            <h1>Payment Report</h1>
            <p>Loading payments…</p>
          </div>
        </div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* ============================== HERO ============================== */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="wallet" size={13} /> Financial Insights</span>
          <h1>Payment Report</h1>
          <p>Review payment transactions, taxes, refunds and revenue across all bookings.</p>
        </div>
        <div className="prm-hero-actions">
          <form onSubmit={handleSearchSubmit} style={{ margin: 0 }}>
            <div className="prm-search">
              <Icon name="search" size={17} />
              <input
                type="text"
                placeholder="Search by PNR, user or booking…"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              {searchTerm && (
                <button type="button" className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>
              )}
            </div>
          </form>
          <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={toggleFilters} title="Filters">
            <Icon name="search" size={16} />
          </button>
          <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={handleRefresh} title="Refresh">
            <Icon name="refresh" size={16} />
          </button>
          <button className="prm-add-btn" onClick={handleExportReport}>
            <span className="plus"><Icon name="list" size={14} /></span> Export Report
          </button>
        </div>
      </div>

      {error && (
        <div className="prm-callout rose" style={{ marginTop: 20, background: 'var(--rose-soft)', borderColor: 'var(--rose)', color: '#be123c' }}>
          <Icon name="info" size={18} />
          <div>
            <strong>Error</strong>
            <span>{error}</span>
          </div>
        </div>
      )}

      {/* ============================== STATS ============================== */}
      <div className="prm-stats">
        <StatCard icon="wallet" tone="indigo" label="Total Payments" value={totalPayments} hint="All transactions" delay={80} />
        <StatCard icon="check" tone="green" label="Total Revenue" value={formatCurrency(totalRevenue)} hint="Successful payments" delay={160} />
        <StatCard icon="route" tone="amber" label="Success Rate" value={`${successRate}%`} hint={`${successfulPayments}/${totalPayments} payments`} delay={240} />
        <StatCard icon="search" tone="cyan" label="Search Results" value={payments.length} hint="Payments on this page" delay={320} />
      </div>

      {/* ============================== FILTER PANEL ============================== */}
      {showFilters && !loading && (
        <div className="prm-fsec" style={{ marginBottom: 22 }}>
          <header className="prm-fsec-head">
            <span className="prm-fsec-num"><Icon name="search" size={16} /></span>
            <div style={{ flex: 1 }}>
              <h4>Filter Payments</h4>
              <p>Refine the list by user, status, method, dates or amount.</p>
            </div>
            <button className="prm-modal-close" style={{ position: 'static' }} onClick={() => setShowFilters(false)}>×</button>
          </header>

          <div className="prm-fsec-body">
            <div className="prm-fgrid">
              <Field label="PNR No"><input type="text" name="pnr" value={filters.pnr} onChange={handleFilterChange} className="prm-input" placeholder="Enter PNR number" /></Field>
              <Field label="User Name"><input type="text" name="userName" value={filters.userName} onChange={handleFilterChange} className="prm-input" placeholder="Enter user name" /></Field>
              <Field label="User Email"><input type="email" name="userEmail" value={filters.userEmail} onChange={handleFilterChange} className="prm-input" placeholder="Enter user email" /></Field>
              <Field label="User Phone"><input type="text" name="userPhone" value={filters.userPhone} onChange={handleFilterChange} className="prm-input" placeholder="Enter user phone" /></Field>
              <Field label="Booking ID"><input type="text" name="bookingId" value={filters.bookingId} onChange={handleFilterChange} className="prm-input" placeholder="Enter booking ID" /></Field>
              <Field label="Payment Status">
                <select name="status" value={filters.status} onChange={handleFilterChange} className="prm-input prm-select">
                  <option value="All Status">All Status</option>
                  <option value="Confirmed">Completed</option>
                  <option value="Pending">Pending</option>
                  <option value="Failed">Failed</option>
                  <option value="Expired">Expired</option>
                  <option value="Refunded">Refunded</option>
                </select>
              </Field>
              <Field label="Payment Method">
                <select name="method" value={filters.method} onChange={handleFilterChange} className="prm-input prm-select">
                  <option value="All Methods">All Methods</option>
                  <option value="Online">Online</option>
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="UPI">UPI</option>
                </select>
              </Field>
              <Field label="Payment From"><input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} className="prm-input" /></Field>
              <Field label="Payment To"><input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} className="prm-input" /></Field>
              <Field label="Min Amount"><input type="number" name="minAmount" value={filters.minAmount} onChange={handleFilterChange} className="prm-input" placeholder="Minimum" min="0" /></Field>
              <Field label="Max Amount"><input type="number" name="maxAmount" value={filters.maxAmount} onChange={handleFilterChange} className="prm-input" placeholder="Maximum" min="0" /></Field>
            </div>

            <div style={{ display: 'flex', gap: 10, marginTop: 20, flexWrap: 'wrap' }}>
              <button className="prm-btn primary" onClick={applyFilters}>
                <Icon name="check" size={15} /> Apply Filters
              </button>
              <button className="prm-btn ghost" onClick={clearFilters}>
                <Icon name="x" size={15} /> Clear All
              </button>
            </div>

            {isFiltered && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 16, alignItems: 'center' }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--muted)' }}>Active Filters:</span>
                {searchTerm && <span className="prm-tag amber">Search: {searchTerm}</span>}
                {filters.status !== 'All Status' && <span className="prm-tag amber">Status: {filters.status}</span>}
                {filters.method !== 'All Methods' && <span className="prm-tag amber">Method: {filters.method}</span>}
                {Object.entries(filters).map(([key, value]) =>
                  value && key !== 'status' && key !== 'method' && key !== 'startDate' && key !== 'endDate' && (
                    <span key={key} className="prm-tag amber">{key}: {value}</span>
                  )
                )}
                {filters.startDate && <span className="prm-tag amber">From: {filters.startDate}</span>}
                {filters.endDate && <span className="prm-tag amber">To: {filters.endDate}</span>}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ============================== TOOLBAR ============================== */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <span className="prm-tag navy"><Icon name="wallet" size={12} /> Transactions</span>
          {isFiltered && <span className="prm-tag amber">Filtered</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{payments.length}</b> of {totalPayments}</span>
          {searching && <span style={{ color: 'var(--amber-deep)', fontSize: 12 }}>· searching…</span>}
        </div>
      </div>

      {/* ============================== TABLE ============================== */}
      {payments.length === 0 ? (
        <div className="prm-empty">
          <div className="icon"><Icon name={isFiltered ? 'search' : 'wallet'} size={44} /></div>
          <h3>{isFiltered ? 'No payments match your filters' : 'No payments yet'}</h3>
          <p>{isFiltered ? 'Try adjusting your filters or clear them to see all payments.' : 'Payments will appear here once transactions start.'}</p>
          {isFiltered && <button className="prm-btn ghost" onClick={clearFilters}>Clear filters</button>}
        </div>
      ) : (
        <div className="prm-table-wrap">
          <table className="prm-table">
            <thead>
              <tr>
                <th>PNR</th>
                <th>Date & Time</th>
                <th>User</th>
                <th>Base Fare</th>
                <th>Platform</th>
                <th>CGST</th>
                <th>SGST</th>
                <th>IGST</th>
                <th>Total</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, i) => (
                <tr key={payment.id} style={{ animationDelay: `${i * 40}ms` }}>
                  <td><span className="pbo-plate">{getSafeString(payment.pnr)}</span></td>
                  <td>
                    <div className="name">{getSafeString(payment.date)}</div>
                    <div className="sub">{getSafeString(payment.time)}</div>
                  </td>
                  <td>
                    <div className="name">{getSafeString(payment.user)}</div>
                    <div className="sub">{getSafeString(payment.userPhone)}</div>
                  </td>
                  <td>{formatCurrency(payment.baseFare)}</td>
                  <td>{formatCurrency(payment.platformFee)}</td>
                  <td>{formatCurrency(payment.cgst)}</td>
                  <td>{formatCurrency(payment.sgst)}</td>
                  <td>{formatCurrency(payment.igst)}</td>
                  <td><b>{formatCurrency(payment.total)}</b></td>
                  <td>
                    <span className={`prm-status ${getStatusBadgeClass(payment.status, payment.paymentStatus)}`}>
                      {getSafeString(payment.status === 'Confirmed' ? 'Completed' : payment.status)}
                    </span>
                  </td>
                  <td>
                    <div className="prm-row-actions">
                      <button className="prm-btn view sm icon-only" onClick={() => handleViewPayment(payment)} title="View Details" aria-label="View Details"><Icon name="eye" size={14} /></button>
                      {(getSafeLowerCase(payment.status) === 'pending' || getSafeLowerCase(payment.paymentStatus) === 'pending') && (
                        <button className="prm-btn primary sm icon-only" onClick={() => handleProcessPayment(payment)} title="Process Payment" aria-label="Process Payment"><Icon name="check" size={14} /></button>
                      )}
                      {(getSafeLowerCase(payment.status) === 'confirmed' || getSafeLowerCase(payment.paymentStatus) === 'success') && (
                        <button className="prm-btn danger sm icon-only" onClick={() => handleRefundPayment(payment)} title="Refund Payment" aria-label="Refund Payment"><Icon name="wallet" size={14} /></button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ============================== PAGINATION ============================== */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 22, flexWrap: 'wrap' }}>
          <button className="prm-btn ghost" onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
          <span style={{ padding: '11px 16px', fontWeight: 700, color: 'var(--navy-800)' }}>
            Page {currentPage} of {totalPages}
          </span>
          <button className="prm-btn ghost" onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
        </div>
      )}

      {/* ============================================================
       * VIEW PAYMENT MODAL — Modern redesign
       * ============================================================ */}
      {viewingPayment && !isFetchingDetails && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720 }}>
            <div className="prm-modal-head">
              <h3>Payment Details — {getSafeString(viewingPayment.pnr)}</h3>
              <p><Icon name="wallet" size={14} /> {getSafeString(viewingPayment.method)} · {formatCurrency(viewingPayment.total)}</p>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-modal-body">
              <div className="prm-info-grid">
                <div className="prm-info"><div className="l">Total</div><div className="v"><Icon name="wallet" size={17} /> {formatCurrency(viewingPayment.total)}</div></div>
                <div className="prm-info"><div className="l">Status</div><div className="v"><span className={`prm-status ${getStatusBadgeClass(viewingPayment.status, viewingPayment.paymentStatus)}`}>{getSafeString(viewingPayment.status === 'Confirmed' ? 'Completed' : viewingPayment.status)}</span></div></div>
                <div className="prm-info"><div className="l">Method</div><div className="v">{getSafeString(viewingPayment.method)}</div></div>
                <div className="prm-info"><div className="l">Date</div><div className="v">{getSafeString(viewingPayment.date)}</div></div>
              </div>

              <div className="prm-section-title">User</div>
              <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                <div className="prm-info"><div className="l">Name</div><div className="v">{getSafeString(viewingPayment.user)}</div></div>
                <div className="prm-info"><div className="l">Email</div><div className="v" style={{ fontSize: 13 }}>{getSafeString(viewingPayment.userEmail)}</div></div>
                <div className="prm-info"><div className="l">Phone</div><div className="v">{getSafeString(viewingPayment.userPhone)}</div></div>
                <div className="prm-info"><div className="l">Booking</div><div className="v">{getSafeString(viewingPayment.booking)}</div></div>
              </div>

              <div className="prm-section-title">Breakdown</div>
              <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                <div className="prm-info"><div className="l">Base Fare</div><div className="v">{formatCurrency(viewingPayment.baseFare)}</div></div>
                <div className="prm-info"><div className="l">Platform Fees</div><div className="v">{formatCurrency(viewingPayment.platformFee)}</div></div>
                <div className="prm-info"><div className="l">CGST</div><div className="v">{formatCurrency(viewingPayment.cgst)}</div></div>
                <div className="prm-info"><div className="l">SGST</div><div className="v">{formatCurrency(viewingPayment.sgst)}</div></div>
                <div className="prm-info"><div className="l">IGST</div><div className="v">{formatCurrency(viewingPayment.igst)}</div></div>
                <div className="prm-info" style={{ background: 'linear-gradient(135deg, #0b1f44, #1e3a8a)', color: '#e2e8f0' }}>
                  <div className="l" style={{ color: 'rgba(255,255,255,.75)' }}>Total</div>
                  <div className="v" style={{ color: '#fcd34d' }}>{formatCurrency(viewingPayment.total)}</div>
                </div>
              </div>
            </div>

            <div className="prm-modal-foot">
              <button className="prm-btn primary" style={{ padding: '11px 28px' }} onClick={closeViewModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Loading details modal */}
      {viewingPayment && isFetchingDetails && (
        <div className="prm-overlay">
          <div className="prm-form-modal prm-form-modal-sm">
            <div className="prm-skel" style={{ padding: 40 }}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          </div>
        </div>
      )}

      {/* ============================================================
       * PROCESS PAYMENT MODAL — Modern redesign
       * ============================================================ */}
      {processingPayment && (
        <div className="prm-overlay" onClick={closeProcessModal}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="check" size={24} /></span>
                <div>
                  <h3>Process Payment</h3>
                  <p>Confirm and complete this transaction</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeProcessModal}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="prm-info-grid">
                <div className="prm-info"><div className="l">PNR</div><div className="v">{getSafeString(processingPayment.pnr)}</div></div>
                <div className="prm-info"><div className="l">User</div><div className="v">{getSafeString(processingPayment.user)}</div></div>
                <div className="prm-info"><div className="l">Total Amount</div><div className="v" style={{ color: 'var(--navy-900)', fontWeight: 700 }}>{formatCurrency(processingPayment.total)}</div></div>
                <div className="prm-info"><div className="l">Booking</div><div className="v">{getSafeString(processingPayment.booking)}</div></div>
              </div>

              <div className="prm-callout blue" style={{ marginTop: 16 }}>
                <Icon name="info" size={18} />
                <div>
                  <strong>Note</strong>
                  <span>This will mark the payment as completed and confirm the associated booking.</span>
                </div>
              </div>
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={closeProcessModal}>Cancel</button>
                <button className="prm-btn primary" onClick={handleConfirmProcess}>
                  <Icon name="check" size={15} /> Confirm Process
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ============================================================
       * REFUND PAYMENT MODAL — Modern redesign
       * ============================================================ */}
      {refundingPayment && (
        <div className="prm-overlay" onClick={closeRefundModal}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="wallet" size={24} /></span>
                <div>
                  <h3>Refund Payment</h3>
                  <p>Process refund for this transaction</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeRefundModal}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="prm-info-grid">
                <div className="prm-info"><div className="l">PNR</div><div className="v">{getSafeString(refundingPayment.pnr)}</div></div>
                <div className="prm-info"><div className="l">User</div><div className="v">{getSafeString(refundingPayment.user)}</div></div>
                <div className="prm-info"><div className="l">Total Amount</div><div className="v">{formatCurrency(refundingPayment.total)}</div></div>
                <div className="prm-info"><div className="l">Booking</div><div className="v">{getSafeString(refundingPayment.booking)}</div></div>
              </div>

              <div className="prm-fgrid" style={{ marginTop: 16 }}>
                <Field label="Refund Amount" required full>
                  <input
                    type="number"
                    value={refundAmount}
                    onChange={(e) => setRefundAmount(e.target.value)}
                    className="prm-input"
                    placeholder="Enter refund amount"
                  />
                </Field>
                <Field label="Refund Reason" full>
                  <textarea
                    value={refundReason}
                    onChange={(e) => setRefundReason(e.target.value)}
                    className="prm-input"
                    rows="3"
                    placeholder="Enter reason for refund"
                  />
                </Field>
              </div>

              <div className="prm-callout amber" style={{ marginTop: 16 }}>
                <Icon name="info" size={18} />
                <div>
                  <strong>Warning</strong>
                  <span>This action will cancel the booking and process a refund. This cannot be undone.</span>
                </div>
              </div>
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={closeRefundModal}>Cancel</button>
                <button className="prm-btn danger" onClick={handleConfirmRefund}>
                  <Icon name="wallet" size={15} /> Confirm Refund
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentReport;